export default "__VITE_ASSET__C$pBQyue__"